import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import DataTable from 'react-data-table-component';
import { get, del, put, post } from '../../controllers/apiController';

import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

const HedefKitle = () => {
    const [isLoading, setIsLoading] = useState(false);

    const numberFormatter = new Intl.NumberFormat("tr-TR");

    const [targetings, setTargetings] = useState([]);
    const [suggestions, setSuggestions] = useState([]);

    const [formData, setFormData] = useState({
        minAge: 0,
        maxAge: 0,
        description: ""
    });

    useEffect(() => {
        document.title = "Hedef Kitle Önerisi | LEVELUP CRM";
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (formData.description == "") {
            toast.error("Tüm alanları doldurmalısınız!");
            return false;
        }

        setIsLoading(true);
        
        try {
            const response = await post('ai/generate-targeting', {
                minAge: formData.minAge,
                maxAge: formData.maxAge,
                description: formData.description
            });

            setTargetings(response.data);
            setSuggestions(response.suggestions);
            setIsLoading(false);
        } catch (err) {
            toast.error(err.response.data.message || "Öneriler alınırken bir hata oluştu!");
        }
    }

    const paginationComponentOptions = {
        rowsPerPageText: 'Sayfa başına satır:',
        rangeSeparatorText: 'toplam',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Tümü',
        firstPageText: 'İlk',
        previousPageText: 'Önceki',
        nextPageText: 'Sonraki',
        lastPageText: 'Son',
        noRowsPerPage: false,
    };

    const customStyles = {
        noData: {
            style: {
                padding: '24px',
                textAlign: 'center',
            },
        },
    };

    const columns = [
        {
            name: 'Hedef Kitle',
            sortable: true,
            cell: row => (
                <div className="fw-bold d-flex flex-column">
                    {row.name}
                    <span className="text-muted fs-11">{numberFormatter.format(row.audience_size_lower_bound)} - {numberFormatter.format(row.audience_size_upper_bound)}</span>
                </div>
            )
        },
        {
            name: 'Açıklama',
            sortable: true,
            cell: row => (
                <div className="p-2">
                    {row.description}
                </div>
            )
        },
        {
            name: 'Yol',
            sortable: false,
            cell: row => (
                <div className="fw-bold">{row.path.join(' > ')}</div>
            )
        }
    ];

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item">Hedef Kitle Önerisi</li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-header">
                                        <h5 className="card-title">Hedef Kitle Önerisi</h5>
                                    </div>
                                    <div className="card-body custom-card-action p-4">
                                        <div className="row">
                                            <div className="col-md-8">
                                                <form onSubmit={handleSubmit}>
                                                    <div className="mb-3 row">
                                                        <div className="col-md-6">
                                                            <label className="form-label">Minimum Yaş</label>
                                                            <input
                                                                type="number"
                                                                step={1}
                                                                className="form-control"
                                                                value={formData.minAge}
                                                                onChange={(e) => setFormData({ ...formData, minAge: e.target.value })}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label className="form-label">Maksimum Yaş</label>
                                                            <input
                                                                type="number"
                                                                step={1}
                                                                className="form-control"
                                                                value={formData.maxAge}
                                                                onChange={(e) => setFormData({ ...formData, maxAge: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="form-label">Açıklama</label>
                                                        <textarea
                                                            type="text"
                                                            className="form-control"
                                                            value={formData.description}
                                                            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                                            rows={5}
                                                        />
                                                    </div>
                                                    <button type="submit" className="btn btn-primary">Öneri Al</button>
                                                </form>
                                            </div>
                                            <div className="col-md-4">
                                                {isLoading ? (
                                                    <div className="w-100 d-flex align-items-center justify-content-center spinner-wrapper">
                                                        <div class="spinner-border text-primary" role="status">
                                                            <span class="visually-hidden">Yükleniyor...</span>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <ul>
                                                        {suggestions.map(suggestion => (
                                                            <li>{suggestion}</li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-header">
                                        <h5 className="card-title">Hedef Kitleler</h5>
                                    </div>
                                    <div className="card-body custom-card-action p-2">
                                        {isLoading ? (
                                            <div className="w-100 d-flex align-items-center justify-content-center spinner-wrapper">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Yükleniyor...</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="table-responsive mb-3">
                                                <DataTable
                                                    columns={columns}
                                                    data={targetings}
                                                    className="table table-hover mb-0"
                                                    pagination
                                                    responsive
                                                    noDataComponent="Görüntülenecek kayıt bulunamadı"
                                                    paginationComponentOptions={paginationComponentOptions}
                                                    customStyles={customStyles}
                                                    paginationPerPage={100}
                                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    );
};

export default HedefKitle;
